var _path, _path2, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8NauruCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M43.888,22C42.885,11.894,34.36,4,23.989,4C13.619,4,5.094,11.894,4.09,22H43.888z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M4.09,26c1.004,10.106,9.529,18,19.899,18c10.37,0,18.895-7.894,19.899-18H4.09z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#eceff1",
    points: "16.169,26.662 16.838,29.335 18.753,27.355 17.996,30.004 20.645,29.247 18.665,31.162 21.338,31.831 18.665,32.5 20.645,34.416 17.996,33.659 18.753,36.307 16.838,34.327 16.169,37 15.5,34.327 13.584,36.307 14.341,33.659 11.693,34.416 13.673,32.5 11,31.831 13.673,31.162 11.693,29.247 14.341,30.004 13.584,27.355 15.5,29.335"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fdd835",
    d: "M43.989,24c0-0.676-0.045-1.341-0.111-2H4.1c-0.066,0.659-0.111,1.324-0.111,2 c0,0.676,0.045,1.341,0.111,2h39.778C43.945,25.341,43.989,24.676,43.989,24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8NauruCircular);
export default __webpack_public_path__ + "static/media/icons8-nauru-circular.8899cbd19626a50344ad2dc5a88c64b5.svg";
export { ForwardRef as ReactComponent };